export class QuizAnswer {
    public id: number;

    constructor(id: number) {
        this.id = id;
    }
}
